import { Trans, useTranslation, type WithTranslation } from "react-i18next";
import type { QuoteLineMO } from "~/OrdersQuotes/common/components/v2/models";
import { NewVersionMessage } from "~/common/components/Messages/NewVersionMessage";
import { URL_CONTACT_US } from "~/utils/url/staticUrls";

import classes from "./QuoteLineMessages.module.less";
import classNames from "classnames";
import { Alert } from "~/common/m3/Alert/Alert";

export const QuoteLineMessages = ({ entry, className }: { entry: QuoteLineMO; className?: string }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(className, classes.root)}>
      <NewVersionMessage baseProduct={entry.product} />
      {entry.messages.map(getMessage.bind(null, t))}
    </div>
  );
};

function getMessage(t: WithTranslation["t"], code: string) {
  let msg;
  if (code === "page.quoteDetails.message.notAvailable") {
    msg = (
      <Trans i18nKey={code}>
        Item not available for checkout. Please <a href={URL_CONTACT_US}>contact customer service</a>.
      </Trans>
    );
  } else {
    msg = t(code);
  }
  return <Alert severity={"info"}>{msg}</Alert>;
}
